import React, { useEffect, useState } from 'react';
import { teacherApi } from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import StatCard from '../../components/common/StatCard';
import Spinner  from '../../components/common/Spinner';
import { FaClipboardCheck, FaChartBar, FaBullhorn, FaUpload, FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function TeacherDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [grades,    setGrades]    = useState([]);
  const [notices,   setNotices]   = useState([]);
  const [materials, setMaterials] = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    Promise.all([
      teacherApi.getGrades(),
      teacherApi.getNotices(),
      teacherApi.getMaterials({}),
    ]).then(([g, n, m]) => {
      setGrades(g.data.data);
      setNotices(n.data.data.slice(0, 3));
      setMaterials(m.data.data.slice(0, 3));
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  return (
    <div>
      <div className="page-header">
        <h2>Welcome, {user?.first_name}! 👋</h2>
        <p>Here's your teaching overview for today</p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:16, marginBottom:28 }}>
        <StatCard label="My Grades"      value={grades.length}     icon={FaClipboardCheck} color="#0d6efd" />
        <StatCard label="Active Notices" value={notices.length}    icon={FaBullhorn}       color="#f59e0b" />
        <StatCard label="Materials"      value={materials.length}  icon={FaUpload}         color="#10b981" />
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24 }}>
        {/* Quick actions */}
        <div className="sms-card">
          <h5 style={{ fontWeight:600, marginBottom:16 }}>Quick Actions</h5>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            {[
              { label:'Mark Attendance', icon:FaClipboardCheck, to:'/teacher/attendance', color:'#0d6efd' },
              { label:'Enter Marks',     icon:FaChartBar,       to:'/teacher/marks',      color:'#10b981' },
              { label:'Upload Material', icon:FaUpload,         to:'/teacher/materials',  color:'#8b5cf6' },
              { label:'Post Notice',     icon:FaBullhorn,       to:'/teacher/notices',    color:'#f59e0b' },
            ].map(a => (
              <button key={a.to} onClick={() => navigate(a.to)} style={{ padding:'14px', borderRadius:10, background:`${a.color}11`, border:`1px solid ${a.color}33`, cursor:'pointer', display:'flex', flexDirection:'column', alignItems:'center', gap:8 }}>
                <a.icon size={22} color={a.color} />
                <span style={{ fontSize:'0.82rem', fontWeight:500, color:a.color }}>{a.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Recent notices */}
        <div className="sms-card">
          <h5 style={{ fontWeight:600, marginBottom:16 }}>Recent Notices</h5>
          {notices.length > 0 ? notices.map(n => (
            <div key={n.notice_id} style={{ padding:'10px 12px', borderRadius:8, background:'#f9fafb', marginBottom:8, borderLeft:'3px solid #0d6efd' }}>
              <div style={{ fontWeight:500, fontSize:'0.88rem' }}>{n.title}</div>
              <div style={{ color:'#9ca3af', fontSize:'0.75rem', marginTop:3 }}>{new Date(n.created_at).toLocaleDateString()}</div>
            </div>
          )) : <p style={{ color:'#9ca3af' }}>No notices yet</p>}
        </div>
      </div>
    </div>
  );
}
